module.exports = __webpack_public_path__ + "img/06张嘉驿.bac80850.png";